import { Browser } from "@capacitor/browser";
import { Capacitor } from "@capacitor/core";
import { useCallback } from "react";
import { useAnalytics } from "../contexts/analytics/hooks";

export function useOpenMaps() {
	const { trackError } = useAnalytics();
	const openMaps = useCallback(
		async (address: string) => {
			const query = encodeURIComponent(address);
			const isNative = Capacitor.isNativePlatform();
			const isIOS = Capacitor.getPlatform() === "ios";
			const isAndroid = Capacitor.getPlatform() === "android";

			try {
				if (!isNative) {
					// WEB
					const url = `https://www.google.com/maps/search/?api=1&query=${query}`;
					window.open(url, "_blank", "noopener,noreferrer");
					return;
				}

				// NATIVE
				if (isIOS) {
					// iOS: prefer Apple Maps, explainable + reliable; user can switch to Google Maps from there
					await Browser.open({ url: `maps://?q=${query}` }); // Apple Maps
					return;
				}

				if (isAndroid) {
					// Android: geo: is the standard (lets user pick Maps app)
					await Browser.open({ url: `geo:0,0?q=${query}` });
					return;
				}
			} catch (error) {
				// Ignore and fallback to Google Maps web
				trackError("open_maps_error", { address, error: JSON.stringify(error) });
			} finally {
				// Fallback
				await Browser.open({ url: `https://www.google.com/maps/search/?api=1&query=${query}` });
			}
		},
		[trackError],
	);
	return { openMaps };
}
